// Project data with detailed information for each project
export const projectsData = [
  {
    id: 1,
    title: "HackElite",
    shortDescription:
      "HackElite is a nationwide coding competition crafted to test and elevate the problem-solving skills of undergraduates. The second iteration of HackElite, HackElite 2.0 was successfully held in 2025.",
    detailedDescription: `HackElite is a prestigious nationwide coding competition designed to challenge and enhance the problem-solving capabilities of undergraduate students across Sri Lanka. This comprehensive event innovative solution development with professional development workshops led by industry experts.

This iteration of the competition featured multiple phases, including proposal submission, real-world application development, and pitching the final minimum viable product to a panel of esteemed judges. Participants work in teams to solve real world issues with programming solutions, while building valuable networking connections with peers and industry professionals.

Beyond the competitive aspect, HackElite serves as a platform for knowledge exchange and mentorship opportunities with leading tech professionals.`,
    image: "/assets/2025updated/Hackelite.jpg",
    gallery: [
      "/assets/Events/Hackelite12025.jpg",
      "/assets/Events/Hackelite22025.jpg",
      "/assets/Events/Hackelite32025.jpg",
      "/assets/Events/Hackelite42025.jpg",
    ],
    technologies: ["Technology", "Innovation", "Collaboration", "Workshops"],
    location: "Rubert Peiris Auditorium, University of Moratuwa (Finals)",
    date: "21st July - 26th September 2025",
    duration: "2 Months",
    participants: "200+ Applicants",
    sponsors: [
      { name: "Zone24x7", logo: "/assets/Sponsor/Zone.png" },
      { name: "Accelr", logo: "/assets/Sponsor/Accelr.jpg" },
      { name: "Cubemak Labs", logo: "/assets/Sponsor/Cubemak Labs.jpeg" },
      { name: "Flames Pizzeria", logo: "/assets/Sponsor/Flames.jpg" },
      { name: "Aura Digital Labs", logo: "/assets/Sponsor/auraLabs.png" },
      { name: "HackSL", logo: "/assets/Sponsor/hackSL.jpeg" },
    ],
    highlights: [
      "Intensive hackathon with real-world challenges",
      "Workshops Conducted by Industry Experts",
      "Rs. 100,000 total prize pool",
      "Participant ideas graded based on creativity, technical feasibility and real world impact",
      "Certificates awarded to all participants",
    ],
    organizers: "IEEE WIE UoM - HackElite Organizing Committee",
    contact: "ieeewieuom@gmail.com",
  },
  {
    id: 3,
    title: "NurtureNook",
    shortDescription:
      "NurtureNook is a compassionate outreach initiative that supports young children from underprivileged communities.",
    detailedDescription: `NurtureNook represents our dedication to creating positive change in the lives of underprivileged children in our community. This heartwarming initiative focuses on providing essential educational support and creating joyful learning experiences for young minds.

The program involves visits to local schools and community centers, where our volunteers distribute essential school supplies including notebooks, pens, pencils, and educational materials. Beyond material support, we organize interactive learning and entertainment sessions that make education fun and engaging.

Our volunteers conduct creative workshops covering basic literacy and numeracy. These sessions are designed to boost children's confidence, creativity, and enthusiasm for learning while providing them with positive role models and mentorship.`,
    image: "/assets/2025updated/Nurturenook.jpg",
    gallery: [
      "/assets/Events/Nurturenook32025.jpg",
      "/assets/Events/Nurturenook42025.jpg",
      "/assets/Events/Nurturenook52025.jpg",
      "/assets/Events/Nurturenook62025.jpg",
    ],
    technologies: [
      "Community Service",
      "Education",
      "Child Welfare",
      "Interactive Activities",
    ],
    location: "Batawala Kanishta Vidyalaya",
    date: "08th July 2025",
    duration: "10.00 AM - 12.30 PM",
    participants: "100+ Children",
    sponsors: [{ name: "CIAP (Pvt) Ltd", logo: "/assets/Sponsor/ciap.png" }],
    highlights: [
      "Provide essential educational resources to underpriviledged children",
      "Interactive learning sessions and games",
      "Entertainment sessions for young children with music and singing",
      "Monetary contribution to assist the educational institution",
    ],
    organizers: "IEEE WIE UoM - Nuturenook Organizing Committee",
    contact: "ieeewieuom@gmail.com",
  },
  {
    id: 4,
    title: "Futuro",
    shortDescription:
      "Futuro is an inspiring physical event designed to spark the interest of A/L Science students in STEM fields.",
    detailedDescription: `Futuro is a physical event crafted specifically for Advanced Level Science students, aimed at broadening their academic and career horizons by igniting a passion for STEM. At a pivotal moment in their educational journey, attendees were introduced to cutting-edge developments in technology, innovation, and university life — inspiring them to consider exciting futures in science, technology, engineering, and mathematics.

The event featured engaging sessions led by accomplished professionals and academics from diverse STEM fields, offering students an authentic look at real-world career paths, industry expectations, and emerging opportunities in the rapidly evolving tech landscape. Through motivational talks, interactive discussions, and firsthand insights into university life, Futuro bridged the gap between the classroom and the world beyond it.

By combining career guidance with a broader introduction to STEM culture and innovation, Futuro empowered students to make informed decisions about their futures and take their first confident steps toward a career in engineering or technology.`,
    image: "/assets/2025updated/Futuro.jpeg",
    gallery: [
      "/assets/Events/Futuro1.jpeg",
      "/assets/Events/Futuro2.jpeg",
      "/assets/Events/Futuro3.jpeg",
      "/assets/Events/Futuro4.jpg",
    ],
    technologies: [
      "STEM",
      "Career Guidance",
      "Workshops",
      "Motivational Talks",
    ],
    location: "Princess of Wales College, Moratuwa",
    date: "April 9, 2025",
    duration: "8.30 am onwards",
    participants: "60+ A/L Students",
    sponsors: [
      {
        name: "Wavenet International (Pvt) Ltd",
        logo: "/assets/Sponsor/Wavenet.jpeg",
      },
    ],
    highlights: [
      "Career guidance from industry experts",
      "Advice about University life and paths ahead",
      "Introduction to STEM pathways of higher education",
      "Interactive Q&A sessions",
    ],
    organizers: "IEEE WIE UoM - Futuro Organizing Committe",
    contact: "ieeewieuom@gmail.com",
  },
  {
    id: 5,
    title: "Hervolution",
    shortDescription:
      "HerVolution is a technical blog series designed to encourage undergraduates to share their ideas, spark creativity, and enhance their writing and communication skills.",
    detailedDescription: `HerVolution is a technical blog series designed to encourage undergraduates at the University of Moratuwa to share their ideas, spark creativity, and enhance their writing and communication skills. Serving as a dedicated platform for young women in engineering, HerVolution empowers participants to showcase their technical knowledge, perspectives, and experiences with a broader audience.

Published bi-weekly on Medium, the series covers a diverse range of topics in technology and innovation — from technical tutorials and industry insights to personal growth stories and academic reflections. Each article contributes to a growing repository of knowledge that benefits the wider university community and beyond.

At its core, HerVolution fosters a sense of community and mutual support among its participants, helping them develop their personal brand, establish themselves as emerging voices in STEM, and inspire their peers through the power of thoughtful, creative writing.`,
    image: "/assets/2025/Hervolution.jpg",
    gallery: ["/assets/2025/Hervolution.jpg"],
    technologies: [
      "Blogging",
      "Content Creation",
      "Knowledge Sharing",
      "Medium",
      "Creativity",
    ],
    location: "Digital Platform - Medium",
    date: "Bi-weekly throughout 2024 and 2025",
    duration: "2024 - Ongoing",
    participants: "20+ Contributors",
    sponsors: [{ name: "GAFE", logo: "/assets/Sponsor/Gafe.png" }],
    highlights: [
      "Bi-weekly publication on Medium",
      "Technical and personal growth articles",
      "Promoting article and creative writing",
      "Community knowledge sharing",
      "Personal branding development",
    ],
    organizers: "IEEE WIE UoM Volunteers",
    contact: "ieeewieuom@gmail.com",
  },
  {
    id: 6,
    title: "Radiance",
    shortDescription:
      "Radiance is the Annual General Meeting and Award Ceremony of IEEE WIE UoM.",
    detailedDescription: `Radiance represents the pinnacle celebration of IEEE WIE UoM's annual achievements and community contributions. This prestigious Annual General Meeting and Award Ceremony brings together members, volunteers, sponsors, and distinguished guests to commemorate the year's milestones and recognize outstanding contributions.

The event features comprehensive presentations of annual activities, financial reports, and future strategic plans. It serves as a platform for community engagement, networking, and celebrating the collective achievements of all members and volunteers.

Through various award categories, Radiance honors exceptional leadership, volunteer service, academic excellence, and innovative contributions that have made a significant impact on the WIE community and beyond.`,
    image: "/assets/2025updated/Radiance.jpg",
    gallery: [
      "/assets/Events/Radiance22025.jpg",
      "/assets/Events/Radiance32025.jpg",
      "/assets/Events/Radiance42025.jpg",
      "/assets/Events/Radiance52025.jpg",
    ],
    technologies: [
      "AGM",
      "Awards Ceremony",
      "Community Building",
      "Recognition",
    ],
    location: "Rubert Peiris Auditorium, University of Moratuwa",
    date: "February 14, 2026",
    duration: "4 hours",
    participants: "50+ Members and Guests",
    sponsors: [{ name: "GAFE", logo: "/assets/Sponsor/Gafe.png" }],
    highlights: [
      "Annual reports and achievement presentations",
      "Outstanding volunteer recognition",
      "Election of next term's Office Bearers",
      "Strategic planning discussions",
      "Appreciation of Volunteers of events",
    ],
    organizers: "IEEE WIE UoM - Radiance Organizing Committee",
    contact: "ieeewieuom@gmail.com",
  },
  {
    id: 7,
    title: "FestX",
    shortDescription:
      "FestX is an exciting event celebrating the grand inauguration of the IEEE WIE Student Branch Affinity Group at the University of Moratuwa.",
    detailedDescription: `FestX was organised to celebrate the grand inauguration of the IEEE WIE Student Branch Affinity Group at the University of Moratuwa, marking the beginning of an impactful journey for women in engineering. The event welcomed the new batch of students and offered them a vibrant opportunity to engage with senior members in a fun and creative environment.

At the heart of FestX were two exciting competitions: WebX, a web design competition challenging participants to build their own personal portfolio websites, and MemeX, a lighthearted competition where students crafted humorous and relatable memes about university life. Together, these competitions blended technical skill with creativity, making for an energetic and memorable experience.

With the final event held physically, FestX fostered a real sense of community, belonging, and camaraderie among participants — setting the tone for the WIE community's mission to empower, inspire, and connect women in STEM.`,
    image: "/assets/2025updated/FestX12025.JPG",
    gallery: ["/assets/Events/FestX22025.JPG"],
    technologies: [
      "Inauguration",
      "Competitions",
      "Workshops",
      "Technical Skills",
    ],
    location: "Online - Via Google Meet",
    date: "Dec 20 2025",
    duration: "6.30pPM - 8.30PM",
    participants: "50+ Participants",
    sponsors: [
      {
        name: "AtLink Communications (Pvt) Ltd.",
        logo: "/assets/Sponsor/AtLink.jpeg",
      },
      {
        name: "Infsoft Lanka (Pvt) Ltd.",
        logo: "/assets/Sponsor/Infosoft.jpeg",
      },
    ],
    highlights: [
      "Inaugural celebration of IEEE WIE Affinity Group at UoM",
      "MemeX –  a fun competition where students crafted humorous and relatable university life memes",
      "WebX – portfolio-building competition",
      "Workshops to upskill participants",
    ],
    organizers: "IEEE WIE UoM - FestX Organizing Committee",
    contact: "ieeewieuom@gmail.com",
  },
  {
    id: 8,
    title: "Enginuity",
    shortDescription:
      "Enginuity is a multi-session career exploration series that evolved from a single session into four sessions and an industry visit, exposing students to diverse fields in technology and innovation.",
    detailedDescription: `Enginuity is a career exploration series organized by IEEE WIE UoM, created to expose students to a broad range of industries, emerging technologies, and professional pathways. Building on the success of Enginuity 1.0, which began as a single session, Enginuity 2.0 expanded into four sessions and an industry visit, reflecting the growing scope and impact of the initiative.

  The four sessions spanned a broad spectrum of fields, exploring topics including the textile industry, transport and logistics management, neurosymbolic AI, and digital electronics. Through these sessions, students gained valuable exposure to real-world applications, current industry trends, and the diverse opportunities available across technical and interdisciplinary domains.

  The series concluded with an industry visit to WSO2, giving students the opportunity to interact directly with professionals and gain firsthand insight into the tech industry. Altogether, Enginuity created a meaningful learning experience that broadened students' perspectives, strengthened their awareness of evolving career paths, and connected academic learning with industry reality.`,
    image: "/assets/2025updated/Enginuity12025.jpg",
    gallery: [
      "/assets/Events/Enginuity22025.jpg",
      "/assets/Events/Enginuity32025.jpg",
      "/assets/Events/Enginuity42025.jpg",
      "/assets/Events/Enginuity62025.JPG",
    ],
    technologies: [
      "Career Exploration",
      "Industry Exposure",
      "Innovation",
      "Technology",
    ],
    location: "Online / Industry Visit at WSO2",
    date: "Monthly – Throughout 2025",
    duration: "1–2 Hours per Session",
    participants: "Open to all",
    sponsors: [{ name: "WSO2", logo: "/assets/Sponsor/WSO2.png" }],
    highlights: [
      "Covered textile industry, transport and logistics, neurosymbolic AI, and digital electronics",
      "Provided direct exposure to real-world industry trends and career paths",
      "Included an industry visit to WSO2 for firsthand professional insight",
    ],
    organizers: "IEEE WIE UoM Volunteers",
    contact: "ieeewieuom@gmail.com",
  },
  {
    id: 9,
    title: "EmpowerHer",
    shortDescription:
      "In celebration of International Women's Day, EmpowerHer was a webinar designed to inspire participants to build their personal brand.",
    detailedDescription: `EmpowerHer was a special webinar organized by IEEE WIE UoM in celebration of International Women's Day, themed "Building Your Personal Brand: Stand Out & Shine." The event brought together inspiring speakers and engaged participants in an empowering conversation about personal and professional identity.

The webinar guided participants through the process of identifying their unique strengths, values, and passions, and translating these into a compelling personal brand. Attendees learned practical strategies for standing out in competitive environments, building an authentic online presence, and communicating their value with confidence.

EmpowerHer was designed not only to inform but to inspire — encouraging every participant to recognize their potential, embrace their individuality, and move forward with purpose and clarity.`,
    image: "/assets/2025updated/EmpowerHer12025.JPG",
    gallery: ["/assets/Events/EmpowerHer22025.JPG"],
    technologies: [
      "Webinar",
      "Personal Branding",
      "Women's Day",
      "Inspiration",
    ],
    location: "Online",
    date: "March 17, 2025",
    duration: "2 Hours",
    participants: "Open to all",
    sponsors: [],
    highlights: [
      "International Women's Day special event",
      "Themed 'The practice of empowerment as a woman, a conversation on equality'",
      "Inspiring talks from accomplished speaker",
    ],
    organizers: "IEEE WIE UoM Volunteers",
    contact: "ieeewieuom@gmail.com",
  },
];
